import React from 'react'
import styled from 'styled-components'
import { ProjectsDataTable } from '../../Components/Inventory/Projects/ProjectsDataTable'
import { ProjectsFirst } from '../../Components/Inventory/Projects/ProjectsFirst'
import { colors } from '../../Shared/colors'

export const ProjectsComponent = () => {
  return (
    <Main>
        <ProjectsFirst/>
        <ProjectsDataTable/>
    </Main>
  )
}


const Main = styled.div`
background-color: ${colors.inputWhite};
min-height: calc(100vh - 10vh);
margin-top: 10vh;
display: flex;
padding-top: 2em;
flex-direction: column;
justify-content: center;
align-items: center;
`